export function getCookie(key) {
  const arr = document.cookie.split('; ').find(row => row.startsWith(`${key}=`))
  return arr ? arr.split(`${key}=`)[1] : null
}
